import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { Observable } from "rxjs";
import { PeriodType } from "../../../../../models/types/filter.types";
import { toObservable } from "@angular/core/rxjs-interop";
import { ViewsDatepickerDirective } from "@bitwarden/web-vault/app/directives/views-datepicker.directive";
import { TIME_DIRECTION_LATER } from "@bitwarden/web-vault/app/components/date-picker/calendar/calendar.component";
import { calculatePickerTranslateValue, isMobileScreen } from "../datepicker-utils";

@Component({
  selector: "app-future-views-datepicker",
  templateUrl: "./future-views-datepicker.component.html",
})
export class FutureViewsDatepickerComponent
  extends ViewsDatepickerDirective
  implements AfterViewChecked
{
  @ViewChild("startPicker", { read: ElementRef }) startPicker!: ElementRef;
  @ViewChild("endPicker", { read: ElementRef }) endPicker!: ElementRef;
  startPickerTranslateValue: string = "0";
  endPickerTranslateValue: string = "0";

  constructor(
    protected datePipe: DatePipe,
    protected elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    super(datePipe, elementRef);
  }
  protected readonly LATER = TIME_DIRECTION_LATER;

  ngAfterViewChecked() {
    this.updateStartPickerTranslateValue();
    this.updateEndPickerTranslateValue();
    this.cdr.detectChanges();
  }

  getCurrentDateRangeFilter(date: Date): boolean {
    return date > new Date();
  }

  getSelectedPeriodObservable(): Observable<PeriodType> {
    return toObservable(this.scenarioStore.period.selected);
  }

  updateDate(dateRange: PeriodType) {
    this.scenarioStore.period.updateSelection(dateRange);
  }

  isMobileScreen = isMobileScreen;

  updateStartPickerTranslateValue() {
    this.startPickerTranslateValue = calculatePickerTranslateValue(
      this.startPickerTrigger,
      this.startPicker,
    );
  }

  updateEndPickerTranslateValue() {
    this.endPickerTranslateValue = calculatePickerTranslateValue(
      this.endPickerTrigger,
      this.endPicker,
    );
  }
}
